// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import './TaxiTypeContainer.scss';
import TaxiTypeInput from './TaxiTypeInput';

type Props = {
  taxiTypes: Array<any>,
  handleTaxiTypeChange: Function,
  showAdvanceSimulationParams: boolean,
}

export default class TaxiTypeContainer extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      taxiTypeRatio: {},
      renderTaxiTypes: false,
      percentage: 0,
    };
  }

  componentWillUpdate(nextProps: Props) {
    if (nextProps.taxiTypes !== this.props.taxiTypes) {
      this.setState({
        renderTaxiTypes: true,
      });
    }
    if (nextProps.showAdvanceSimulationParams !== this.props.showAdvanceSimulationParams) {
      this.setState({
        percentage: 0,
      });
    }
  }

  handlePercentageChange = (taxiType: number, event: Object) => {
    const updatedValue = _.ceil(event.target.value / 100, 2) || 0.0;
    const updatedRatio = this.state.taxiTypeRatio;
    const oldValue = updatedRatio[taxiType.toString()] || 0;
    const newPercentage = ((parseInt(this.state.percentage, 10) / 100) - oldValue) + updatedValue;
    updatedRatio[taxiType.toString()] = updatedValue;
    this.setState({
      taxiTypeRatio: updatedRatio,
      percentage: (newPercentage * 100).toFixed(0),
    });

    this.props.handleTaxiTypeChange(updatedRatio, _.round(newPercentage, 2) === 1);
  };

  render() {
    const contents = [];
    if (this.props.taxiTypes.length === 0 || !this.props.showAdvanceSimulationParams) {
      return (
        <div />
      );
    }

    if (this.state.renderTaxiTypes) {
      this.props.taxiTypes.forEach((taxiType) => {
        contents.push(
          <TaxiTypeInput
            taxiType={taxiType}
            handlePercentageChange={this.handlePercentageChange}
            key={taxiType}
          />
        );
      });
    }
    return (
      <div className="taxiTypeContainer table-container">
        <table className="table taxiTypeTable">
          <thead>
            <tr>
              <th className="centralize">Taxi Type</th>
              <th className="centralize alignment">Percentage in Cohort</th>
            </tr>
          </thead>
          <tbody>
            {contents}
          </tbody>
          <tfoot>
            <tr>
              <th className="centralize">Total Percentage:</th>
              <th
                className={classnames('centralize', {
                  'over-limit': (this.state.percentage > 100),
                })}
              >
                {this.state.percentage}%
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/TaxiTypesContainer.js
 **/